import * as React from "react";

function SvgSmsMessenger(props) {
  return <svg fill="none" viewBox="0 0 45 45" {...props}><path fill="currentColor" fillRule="evenodd" d="M22.5 0A21.7 21.7 0 000 21.8C0 28.4 2.7 34.1 7 38c.4.3.7.8.7 1.3l.1 4c0 1.2 1.4 2 2.5 1.5l4.5-2H16c2 .6 4.2.9 6.5.9 12.7 0 22.5-9.3 22.5-21.9C45 9.3 35.2 0 22.5 0zM36 16.8l-6.6 10.5c-1 1.6-3.3 2-4.9.9l-5.2-4c-.5-.3-1.2-.3-1.7 0l-7 5.4c-1 .7-2.2-.4-1.6-1.4l6.6-10.5c1-1.6 3.3-2 4.9-.9l5.2 4c.5.3 1.2.3 1.7 0l7-5.4c1-.7 2.2.4 1.6 1.4z" clipRule="evenodd" /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/sms-messenger_f571ad.svg";
export { SvgSmsMessenger as ReactComponent };